import question from "./question"

const baseAdminRoute = [
    {
        path: "/manage",
        component: () => import("@/views/manage"),
        meta: {
            needAdmin: true
        },
        redirect: { name: "manage-index" },
        children: [
            {
                path: "home",
                name: "manage-index",
                // redirect: { name: "exam-list" },
                component: () => import("@/views/manage/demo"),
                meta: { title: "首页", menuItemActive: 'home', subMenuItem: '/manage/home' }
            },
            {
                path: "user",
                name: "user",
                component: () => import("@/views/manage/CardContainer"),
                meta: { title: "用户管理" },
                redirect: "/manage/user/admin",
                children: [
                    {
                        path: "admin",
                        name: "admin",
                        component: () => import("@/views/manage/user/admin"),
                        meta: { title: "机构管理员" }
                    },
                    {
                        path: "teacher",
                        name: "teacher",
                        component: () => import("@/views/manage/user/teacher/teacher"),
                        meta: { title: "机构教师" }
                    },
                    {
                        path: "list",
                        name: "list",
                        component: () => import("@/views/manage/user/list"),
                        meta: { title: "前台用户" }
                    },
                    {
                        path: "group",
                        name: "group",
                        component: () => import("@/views/manage/user/group"),
                        meta: { title: "用户组" }
                    },
                    {
                        path: "importGroup",
                        name: "importGroup",
                        component: () =>
                            import("@/views/manage/user/importGroup"),
                        meta: { title: "用户组" }
                    }
                ]
            },
            {
                path: "basic",
                name: "basic",
                component: () => import("@/views/manage/CardContainer"),
                meta: { title: "字典管理" },
                redirect: "/manage/basic/category",
                children: [
                    {
                        path: "category",
                        name: "自建分类",
                        component: () =>
                            import("@/views/manage/basic/category"),
                        meta: { title: "自建分类" }
                    },
                    {
                        path: "point",
                        name: "BasicPoint",
                        component: () => import("@/views/manage/basic/point"),
                        meta: { title: "知识点" }
                    },
                    {
                        path: "log",
                        name: "basicLog",
                        component: () => import("@/views/manage/basic/log/log"),
                        meta: { title: "操作日志记录" }
                    }
                ]
            },
            {
                path: "resource",
                name: "resource",
                component: () => import("@/views/manage/CardContainer"),
                meta: { title: "资源管理" },
                redirect: "/manage/resource/common",
                children: [
                    {
                        path: "common",
                        name: "common",
                        component: () =>
                            import("@/views/manage/resource/common"),
                        meta: { title: "公共题库" }
                    },
                    {
                        path: "question",
                        name: "question",
                        component: () =>
                            import("@/views/manage/resource/question"),
                        meta: { title: "试题管理" }
                    },
                    {
                        path: "paper",
                        name: "paper",
                        component: () =>
                            import("@/views/manage/resource/paper"),
                        meta: { title: "试卷管理" }
                    },
                    {
                        name: "resourceCourse",
                        path: "course",
                        component: () =>
                            import("@/views/manage/resource/course/course"),
                        meta: { title: "课程管理", alive: false, menuItemActive: 'course', subMenuItem: '/manage/resource' }
                    },
                    {
                        name: "AddCourse",
                        path: "course/add",
                        component: () => import("@/views/manage/resource/course/add/add"),
                        meta: { title: "新增课程", hidden: true, menuItemActive: 'course', subMenuItem: '/manage/resource' }
                    },
                    {
                        name: "courseDetail",
                        path: "course/detail",
                        component: () => import("@/views/manage/resource/course/detail/detail"),
                        meta: { title: "课程详情", hidden: true, menuItemActive: 'course', subMenuItem: '/manage/resource' }
                    },
                    {
                        path: "addPaper",
                        name: "addPaper",
                        component: () =>
                            import("@/views/manage/resource/addPaper"),
                        meta: {
                            title: "新增试卷",
                            hidden: true,
                        }
                    },
                    {
                        path: "addQue",
                        name: "addQue",
                        component: () =>
                            import("@/views/manage/resource/addQue"),
                        meta: {
                            title: "新增试卷",
                            hidden: true
                        }
                    }
                ]
            },
            {
                path: "exam",
                name: "exam-index",
                component: () => import("@/views/manage/CardContainer"),
                meta: { title: "考试管理" },
                redirect: "/manage/exam/create-exam",
                children: [
                    {
                        path: "create-exam",
                        name: "create-exam",
                        component: () =>
                            import("@/views/manage/exam/create-exam"),
                        meta: { title: "创建考试", hidden: true}
                    },
                    {
                        path: "exam-list",
                        name: "exam-list",
                        component: () =>
                            import("@/views/manage/exam/exam-list"),
                        meta: { title: "考试列表" }
                    },
                    {
                        path: "correct-exam",
                        name: "correct-exam",
                        component: () =>
                            import("@/views/manage/exam/correct-exam"),
                        meta: { title: "考试阅卷" }
                    },
                    {
                        path: "correct-exam2",
                        name: "correct-exam2",
                        component: () =>
                            import("@/views/manage/exam/correct-exam2"),
                        meta: {
                            title: "考试阅卷",
                            hidden: true
                        }
                    },
                    {
                        path: "exam-results",
                        name: "exam-results",
                        component: () =>
                            import("@/views/manage/exam/exam-results"),
                        meta: { title: "考试成绩" }
                    },
                    {
                        path: "exam-results2",
                        name: "exam-results2",
                        component: () =>
                            import("@/views/manage/exam/exam-results2"),
                        meta: {
                            title: "考试成绩",
                            hidden: true
                        },
                    },
                    {
                        path: "exam-results2-records",
                        name: "exam-results2-records",
                        component: () =>
                            import("@/views/manage/exam/exam-results2-records"),
                        meta: {
                            title: "试卷导出记录",
                            hidden: true
                        },
                    },
                    {
                        path: "result-statistics",
                        name: "result-statistics",
                        component: () =>
                            import("@/views/manage/exam/result-statistics"),
                        meta: { title: "成绩统计" }
                    },
                    {
                        path: "result-statistics2",
                        name: "result-statistics2",
                        component: () =>
                            import("@/views/manage/exam/result-statistics2"),
                        meta: {
                            title: "考试成绩",
                            hidden: true
                        }
                    }
                ]
            },
            ...question.sidebarRoutes,
            {
                path: "/manage/paperImport",
                name: "ManagePaperImport",
                component: () => import("@/views/manage/paperImport/paperImport"),
                meta: {
                    title: "试卷导入",
                }
            },
        ]
    },
    {
        path: "/manage/statistic",
        name: "statistic",
        component: () => import("@/views/manage/statistic/statistic")
    },
    {
        path: "/manage/previewExam",
        name: "previewExam",
        component: () => import("@/views/manage/previewExam")
    },
    {
        path: "/manage/gradingPaper",
        name: "gradingPaper",
        component: () => import("@/views/manage/gradingPaper")
    },
    {
        path: "/manage/examResultPaper",
        name: "examResultPaper",
        component: () => import("@/views/manage/exam/result-print")
    },
    {
        path: "/manage/do-questionnaire",
        name: "ManageDoQuestionnaire",
        component: () => import("@/views/manage/psq/msq/doQuestionnaire/index"),
        meta: {
            title: "查看问卷答案",
        }
    },
    {
        path: "/manage/view-question",
        name: "ManageViewQuestion",
        component: () => import("@/views/manage/psq/msq/view-question/index"),
        meta: {
            title: "查看预览问卷",
        }
    },
    ...question.manageRoutes
];

export { baseAdminRoute };
